export default __webpack_public_path__ + "static/media/old-transaction-icon.bae393d6.png";